import React from 'react';
import _ from 'lodash';

import {
  useUserRoleTemplateSelectFieldQuery,
  VisibilityScopeName
} from 'generated/graphql';



export interface IUserRoleTemplate {
  id: string;
  visibilityScopeName: VisibilityScopeName;
  displayName: string;
}

export interface IData {
  objects: IUserRoleTemplate[];
}

export function useQuery() {
  const queryTuple = useUserRoleTemplateSelectFieldQuery({
    variables: {}
  });

  const wrappedTuple = React.useMemo(() => {
    const data: IData = {
      objects: _.map(queryTuple.data?.userRoleTemplates.nodes ?? [], (node): IUserRoleTemplate => ({
        id: node.id,
        visibilityScopeName: node.visibilityScope.name,
        displayName: node.displayName
      }))
    };

    return {
      loading: queryTuple.loading,
      data,
      refetch: async () => {
        queryTuple.refetch({});
      }
    };
  }, [queryTuple]);

  return wrappedTuple;
}
